import { createAsyncAction } from 'typesafe-actions';
import { FetchBuildingSettingsParams, FetchBuildingSettingsSuccessDto, FetchBuildingSettingsErrorDto } from './types';

export const fetchBuildingSettings = createAsyncAction(
  'BUILDING_SETTINGS/FETCH_REQUEST',
  'BUILDING_SETTINGS/FETCH_SUCCESS',
  'BUILDING_SETTINGS/FETCH_FAILURE',
)<FetchBuildingSettingsParams, FetchBuildingSettingsSuccessDto, FetchBuildingSettingsErrorDto>();
